import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { FolderTree, List,  ChevronLeft, Cog, Activity, BarChart } from 'lucide-react';
import { PERMISSIONS } from '../../utils/constants';

const AssetsNavBar = ({ onNavigate, currentSelection }) => {
  const { permissions } = useAuth();
  const { theme } = useTheme();
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth > 768);

  const navItems = [
    {
      name: 'Hierarchy',
      icon: <FolderTree className="w-5 h-5" />,
      id: 'hierarchy',
      permission: PERMISSIONS.ASSETS.VIEW_ASSETS_HIERARCHY
    },
    {
      name: 'Assets',
      icon: <Cog className="w-5 h-5" />,
      id: 'assets',
      permission: PERMISSIONS.ASSETS.VIEW_ASSETS_LIST
    },
    {
      name: 'Points',
      icon: <Activity className="w-5 h-5" />,
      id: 'points',
      permission: PERMISSIONS.ASSETS.VIEW_POINTS_LIST
    },
    {
      name: 'Analysis',
      icon: <BarChart className="w-5 h-5" />,
      id: 'analysis',
      permission: PERMISSIONS.ASSETS.VIEW_POINTS_ANALYSIS
    }
  ];

  const hasPermission = (permission) => {
    return permissions?.includes(permission);
  };

  return (
    <nav className={`h-[calc(100vh-40px)] flex flex-col ${isCollapsed ? 'w-8 md:w-16' : 'w-8 md:w-48'} transition-all duration-300 rounded-r-xl
      ${theme === 'light' ? 'bg-white border-r border-gray-300/50' : 'bg-slate-900/90 border-r border-gray-700/50'}`}>
      {/* Collapse Toggle Button */}
      <button 
        onClick={() => setIsCollapsed(!isCollapsed)}
        className={`hidden md:block self-end p-0.5 md:p-1 m-0.5 md:m-1 rounded-lg transition-colors
          ${theme === 'light' 
            ? 'text-slate-600 hover:bg-slate-100' 
            : 'text-slate-300 hover:bg-slate-700'}`}
      >
        <ChevronLeft className={`w-4 h-4 md:w-5 md:h-5 transition-transform duration-300 ${isCollapsed ? 'rotate-180' : ''}`} />
      </button>

      {/* Navigation Items */}
      <div className={`flex-1 px-0.5 md:px-1 space-y-1 md:space-y-2 ${isCollapsed ? 'hidden md:block' : ''}`}>
        {navItems.map((item, index) => (
          hasPermission(item.permission) && (
            <button
              key={index}
              onClick={() => onNavigate(item.id)}
              className={`w-full flex items-center px-2 md:px-4 py-2 md:py-3 rounded-lg text-xs md:text-sm font-semibold transition-all duration-300
                ${currentSelection === item.id 
                  ? 'bg-gradient-to-r from-purple-500 to-fuchsia-600 text-white shadow-lg shadow-purple-500/30' 
                  : ''}
                ${theme === 'light' 
                  ? `${currentSelection !== item.id ? 'text-slate-700 hover:bg-slate-100' : ''}`
                  : `${currentSelection !== item.id ? 'text-slate-200 hover:bg-slate-700' : ''}`
                }
                ${isCollapsed ? 'justify-center' : 'justify-center md:justify-start'}`}
              title={item.name}
            >
              {item.icon}
              {!isCollapsed && <span className="ml-3 hidden md:inline">{item.name}</span>}
            </button>
          )
        ))}
      </div>
    </nav>
  );
};

export default AssetsNavBar;
